import React from "react";
import CustomerForm from "./CustomerForm";

export default function AddCustomer() {
  return <CustomerForm type="Add" />;
}
